import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { Outlet } from "react-router";
import { setUnauthorizedHandler } from "./api/client";
import { qk } from "./api/session";
import { ThemeProvider } from "./layout/ThemeProvider";
import { UpdatePrompt } from "./pwa/UpdatePrompt";

/** Tema do app e, para qualquer 401 da API, derruba a sessão em cache; o RequireSession leva ao login e volta depois. */
export function RootLayout() {
  const qc = useQueryClient();
  useEffect(() => {
    setUnauthorizedHandler(() => qc.setQueryData(qk.me, null));
    return () => setUnauthorizedHandler(undefined);
  }, [qc]);
  return (
    <ThemeProvider>
      <Outlet />
      <UpdatePrompt />
    </ThemeProvider>
  );
}
